import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgModule } from '@angular/core';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxColModule } from './rx-col';
import { RxDialogComponent } from '@nrwl/rx-dialog';
import { RxDialogModule } from './rx-dialog';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxInputModule } from './rx-input';
import { RxListModule } from './rx-list';
import { RxRadioGroupModule } from './rx-radio-group';
import { RxRowComponent } from './rx-row/rx-row.component';
import { RxRowModule } from '@nrwl/rx-row';
import { RxToggleModule } from './rx-toggle';
import { RxUploadThumbnailModule } from './rx-upload-thumbnail/rx-upload-thumbnail.module';
import { RxSnackbarModule } from '@nrwl/rx-snackbar';
import { RxRoatingArrowModule } from './rx- rotating-arrow';
import { RxPopoverAuthModule } from './rx-popover-auth';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatExpansionModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    RxInputModule,
    RxButtonModule,
    RxIconModule,
    RxDialogModule,
    RxColModule,
    RxRowModule,
    RxRadioGroupModule,
    RxToggleModule,
    RxListModule,
    RxUploadThumbnailModule,
    RxSnackbarModule,
    RxRoatingArrowModule,
    RxPopoverAuthModule,
  ],
  exports: [
    RxRowComponent,
    MatDialogModule,
    RxDialogComponent,
    RxColModule,
    RxRowModule,
    RxInputModule,
    RxRadioGroupModule,
    RxToggleModule,
    RxListModule,
    RxButtonModule,
    MatButtonModule,
    RxUploadThumbnailModule,
    RxSnackbarModule,
    RxRoatingArrowModule,
    RxPopoverAuthModule,
  ],
})
export class RxUiModule {}
